import React from "react";
import QRCode from "qrcode.react"
import uuidv4 from "uuid"
import "./Sessions.css"
import "./Commons.css"
import deleteBtnImage from "./Images/delete_icon.png"
import createBtnImage from "./Images/add_icon.png"
import backBtnImage from "./Images/backarrow.png"
import * as App from "./App"
import * as RestApi from "./RestApi"
import {InfoListButton} from "./Containers"
import {checkMikaResponseSuccess} from "./RestApi";

export class SessionsView extends React.Component {
    constructor(props) {
        super(props);
        this.state = {isEditing: false, editedSession: null};
        this.setSessionEditEnabled = this.setSessionEditEnabled.bind(this);
    }

    setSessionEditEnabled(enabled, session) {
        this.setState({isEditing: enabled, editedSession: (enabled ? session : null)});
        // Refresh view when edit mode gets disabled
        if (!enabled)
            this.props.changeView(App.EAppView.Sessions);
    }

    render() {
        // Render session edit panel.
        if (this.state.isEditing) {
            return (
                <SessionEditorPanel setSessionEditEnabled={this.setSessionEditEnabled}
                                  session={this.state.editedSession}/>
            );
        }

        // Empty view
        if (this.props.sessions == null)
            return (
                <div className="SessionsContainer">
                    <CreateNewSessionButton setSessionEditEnabled={this.setSessionEditEnabled}/>
                </div>
            );
        const sessions = this.props.sessions.map((ses) => <SessionsListItem key={ses.id}
                                                                            info={ses.name + " - " + ses.id}
                                                                            session={ses}
                                                                            onClick={this.setSessionEditEnabled.bind(this, true, ses)}
                                                                            changeView={this.props.changeView}/>);
        // View with list of sessions.
        return (
            <div className="SessionsContainer">
                <div className="ViewListHeader">
                    <div>Nome - ID Sessione</div>
                    <div>Elimina<br/>sessione</div>
                </div>
                {sessions}
                <CreateNewSessionButton setSessionEditEnabled={this.setSessionEditEnabled}/>
            </div>
        );
    }
}

export function SessionsListItem(props) {
    let session = props.session;
    return (
        <div className="ViewListItemWideFlex">
            <InfoListButton onClick={props.onClick} info={props.info}/>
            <DeleteSessionButton changeView={props.changeView} sesId={session.id}/>
        </div>
    );
}

export function DeleteSessionButton(props) {
    function deleteSession(e) {
        e.preventDefault();
        var confirmation = window.confirm("Confermi eliminazione?");
        if (confirmation) {
            RestApi.deleteSession(props.sesId).then((json) => {
                console.log(json);
                props.changeView(App.EAppView.Sessions);
            });
        }
    }

    return (
        <button className="DeleteListItemButton" onClick={deleteSession}>
            <img alt="Delete Session" className="imgFitParent" src={deleteBtnImage}/>
        </button>);
}

export function CreateNewSessionButton(props) {
    function createSession() {
        const sesName = window.prompt("Nome sessione:");
        if (sesName != null)
            RestApi.createSession(sesName).then(async (resp) => {
                if (await checkMikaResponseSuccess(resp))
                    props.setSessionEditEnabled(true, resp);
            });
    }

    return (
        <div className="newListItemContainer">
            <div>Crea nuova sessione</div>
            <button className="CreateNewListItemButton" onClick={createSession}>
                <img alt="Create Session" src={createBtnImage} className="imgFitParent"/>
            </button>
        </div>
    )
}

class SessionEditorPanel extends React.Component {
    constructor(props) {
        super(props);
        this.state = {session: props.session};
        this.refreshSessionInfo = this.refreshSessionInfo.bind(this);
        this.updateSessionName = this.updateSessionName.bind(this);
    }

    async updateSessionName() {
        const newName = window.prompt("Nuovo nome:");
        if (newName == null) return;
        const resp = await RestApi.updateSessionName(this.state.session.id, newName);
        if (resp == null) {
            console.error(resp);
            alert("Errore di comunicazione con il server.");
            return;
        }
        if (!resp.success) {
            console.error(resp);
            alert(`Errore: ${await resp.text()}`);
            return;
        }
        let session = this.state.session;
        session.name = newName;
        this.setState({session: session});
    }

    async refreshSessionInfo() {
        const resp = await RestApi.getSessionInfo(this.state.session.id);
        if (resp == null || !resp.success) {
            console.error(resp != null ? await resp.text() : "Server did not respond.");
            alert("Errore di comunicazione con il server.");
            return;
        }
        this.setState({session: resp});
    }

    componentDidMount() {
        this.timerId = setInterval(this.refreshSessionInfo, 3000);
    }

    render() {
        let session = this.state.session;
        if (session == null) return <BackButton onClick={this.props.setSessionEditEnabled.bind(null, false, null)}/>
            ;
        return (
            <div className="FullSizeFlexRow">
                <div className="SessionEditLeftSide">
                    <BackButton onClick={this.props.setSessionEditEnabled.bind(null, false, null)}/>
                    <QRCode value={session.id} level="M" className="QrCodeBox" size={1024}
                            style={{height: "auto", width: "100%"}}/>

                </div>
                <div className="SessionEditInfoBox">
                    <div className="SessionEditIdNameSection">
                        <p className="smallHeader">Codice ID Sessione</p>
                        <p className="SessionEditIdText">{session.id}</p>
                        <br/>
                        <p className="smallHeader">Clicca per cambiare il nome della sessione</p>
                        <button className="EditSessionNameButton"
                                onClick={this.updateSessionName}>{session.name}</button>
                    </div>
                    <PlayerList players={session.players} maxPlayers={5} sesId={session.id}
                                refreshSessionInfo={this.refreshSessionInfo}/>
                </div>
            </div>
        );
    }

    componentWillUnmount() {
        clearInterval(this.timerId);
    }
}

function PlayerList(props) {
    let playerSlots = new Array(props.maxPlayers).fill(null);
    const players = playerSlots.map((slot, i) => {
        const isValidPlayer = ((i < props.players.length) && (props.players[i] != null));
        return <PlayerItem key={isValidPlayer ? props.players[i].player_id : uuidv4()}
                           player={isValidPlayer ? props.players[i] : null}
                           sesId={props.sesId} refreshSessionInfo={props.refreshSessionInfo}/>;
    });
    return (
        <div className="SessionEditPlayerBox">
            <p className="smallHeader leftAlign">Giocatori</p>
            {players}
        </div>
    );
}

function PlayerItem(props) {
    async function kickPlayer(player) {
        const confirm = window.confirm(`Rimuovere giocatore ${player.name}?`);
        if (!confirm) return;

        const resp = await RestApi.removePlayerFromSession(props.sesId, player);
        if (resp == null) {
            console.error(resp);
            alert("Errore di comunicazione con il server.");
            return;
        }
        if (!resp.success) {
            console.warn("Could not remove player: " + await resp.text());
            return;
        }

        props.refreshSessionInfo();
    }

    const player = props.player;
    if (player == null)
        return <div className="PlayerItem"><p>In attesa del giocatore...</p></div>;
    return <div className="PlayerItem PlayerReady"><p>{player.name}</p>
        <button className="KickPlayerButton" onClick={kickPlayer.bind(null, player)}><img alt="Delete Player"
                                                                                          className="imgFitParent"
                                                                                          src={deleteBtnImage}/>
        </button>
    </div>;
}

function BackButton(props) {
    return (
        <button onClick={props.onClick} className="BackButton">
            <img alt="Back" src={backBtnImage} className="imgFitParent"/>
        </button>
    );
}